var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "orders-list-view" } },
    [
      _c(
        "material-card",
        {
          attrs: { color: "primary", icon: "mdi-account-multiple" },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function() {
                return [_vm._v(" Order Requests ")]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "div",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.customerRequests,
                  "single-expand": "",
                  "show-expand": "",
                  "fixed-header": "",
                  height: _vm.height,
                  "item-key": "id",
                  loading: _vm.loading,
                  "loading-text": "Loading... Please wait"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "item.shipping_address",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _vm._v(
                            " " +
                              _vm._s(item.shipping_address.street1) +
                              " " +
                              _vm._s(item.shipping_address.street2) +
                              " "
                          ),
                          _c("br"),
                          _vm._v(
                            " " +
                              _vm._s(item.shipping_address.city) +
                              ", " +
                              _vm._s(item.shipping_address.state) +
                              " " +
                              _vm._s(item.shipping_address.zip) +
                              " "
                          )
                        ]
                      }
                    },
                    {
                      key: "item.alerts",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          item.alerts
                            ? _c("v-chip", { attrs: { color: "warning" } }, [
                                _vm._v(" " + _vm._s(item.alerts) + " ")
                              ])
                            : _vm._e()
                        ]
                      }
                    },
                    {
                      key: "item.data-table-expand",
                      fn: function(ref) {
                        var item = ref.item
                        var isExpanded = ref.isExpanded
                        var expand = ref.expand
                        return [
                          item.products.length > 0
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "v-data-table__expand-icon",
                                  class: {
                                    "v-data-table__expand-icon--active": isExpanded
                                  },
                                  attrs: { icon: "" },
                                  on: {
                                    click: function($event) {
                                      return expand(!isExpanded)
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("mdi-chevron-down")])],
                                1
                              )
                            : _vm._e()
                        ]
                      }
                    },
                    {
                      key: "item.actions",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c(
                            "v-menu",
                            {
                              attrs: { bottom: "", right: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  dark: "",
                                                  icon: "",
                                                  color: "primary"
                                                }
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c("v-icon", [
                                              _vm._v("mdi-dots-vertical")
                                            ])
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _c(
                                "v-list",
                                [
                                  item.customer_id
                                    ? _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.openCustomer(
                                                item.customer_id
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            [
                                              _c("v-icon", [
                                                _vm._v("mdi-account-search")
                                              ])
                                            ],
                                            1
                                          ),
                                          _c("v-list-item-title", [
                                            _vm._v("View Customer")
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-list-item",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.setCustomer(item)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-list-item-icon",
                                        [
                                          _c("v-icon", [
                                            _vm._v("mdi-cart-plus")
                                          ])
                                        ],
                                        1
                                      ),
                                      _c("v-list-item-title", [
                                        _vm._v("Add to Cart")
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.denyRequest(item.id)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-list-item-icon",
                                        [_c("v-icon", [_vm._v("mdi-delete")])],
                                        1
                                      ),
                                      _c("v-list-item-title", [
                                        _vm._v("Deny Request")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    },
                    {
                      key: "expanded-item",
                      fn: function(ref) {
                        var headers = ref.headers
                        var item = ref.item
                        return [
                          _c(
                            "td",
                            { attrs: { colspan: headers.length } },
                            [
                              _c("v-simple-table", {
                                staticClass: "m-2",
                                attrs: { dense: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function() {
                                        return [
                                          _c("thead", [
                                            _c("tr", [
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("ID")]
                                              ),
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("Name")]
                                              ),
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("Mfg")]
                                              ),
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("Part#")]
                                              ),
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("Case Qty")]
                                              ),
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("Price")]
                                              ),
                                              _c("th", {
                                                staticClass: "text-left"
                                              })
                                            ])
                                          ]),
                                          _c(
                                            "tbody",
                                            _vm._l(item.products, function(
                                              product
                                            ) {
                                              return _c(
                                                "tr",
                                                { key: product.id },
                                                [
                                                  _c("td", [
                                                    _vm._v(_vm._s(product.id))
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(_vm._s(product.name))
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(product.mfg_name)
                                                    )
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(product.mfg_pn)
                                                    )
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        product.purchase_qty
                                                      )
                                                    )
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(product.price)
                                                    )
                                                  ]),
                                                  _c(
                                                    "td",
                                                    [
                                                      _c(
                                                        "v-chip",
                                                        {
                                                          attrs: {
                                                            color:
                                                              product.status_color
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                product.status
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          )
                        ]
                      }
                    },
                    _vm.isEnabled("no-data")
                      ? {
                          key: "no-data",
                          fn: function() {
                            return [_vm._v(" No recent requests found. ")]
                          },
                          proxy: true
                        }
                      : null
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        ]
      ),
      _c("confirmation-modal", { ref: "confirm" }),
      _c("customer-validation-modal", { ref: "customerValidation" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }